/**
 * Estilo compartido del label (Typography) que precede a cada campo del
 * formulario de inventario (patrón "Label con Typography encima" de
 * CLAUDE.md, sin InputLabel flotante). Uso interno de components/forms: NO
 * se exporta en ningún barrel.
 */
export const tituloLabelSx = { fontWeight: 600, mb: 1, color: "#495057", display: "flex", alignItems: "center", gap: 0.5 };
